module.exports = __webpack_public_path__ + "img/art-slide-3-xl.262ca8e.webp";